import React, { Component } from "react";
import { ModalBody, ModalHeader, ModalFooter, Button, Input } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../stores/actions/index";
import { fieldHasError } from "../../helpers/formValidators";
import Select from "react-select";
import { selectStyle } from "../../config/selectStyle";
import { showToast } from "../../helpers/toast";
import "./reports.scss";
import TimezoneSelect from "react-timezone-select";
import moment from "moment-timezone";
import { REPORT_NORMAL } from "./Reports";
import { translate } from "react-i18next";

class AddEditEnvironmentReport extends Component {
  state = {
    mode: "Add",
    formReport: {
      reportName: "",
      tempEnabled: true,
      humidityEnabled: true,
      carbonEnabled: true,
      pressureEnabled: false,
      shtTEnabled: false,
      insightReport: false,
      selectedFreq: 1,
      selectedReportTime: 0,
      selectedGroupData: 0,
      docFormat: 0,
      sortBy: 1,
      notifyAdmin: true,
      alarmEnabled: true,
      offset: 0,
      timezone: "",
      selectedUsers: [],
      selectedDevices: [],
    },
    userId: "",
    deviceId: "",
    dropDownUsers: [],
    dropDownDevices: [],
    reportId: "",
  };

  freqButtons = [
    { label: this.props.t("dashboard.daily"), value: 1 },
    { label: this.props.t("dashboard.weekly"), value: 2 },
    { label: this.props.t("dashboard.monthly"), value: 3 },
  ];

  // const reportTime = [
  //   { label: '1 Day', value: 0 },
  //   { label: '1 Week', value: 1 },
  //   { label: '1 Month', value: 2 },
  //   { label: '3 Months', value: 3 },
  //   { label: '6 Months', value: 4 },
  // ];

  groupData = [
    { label: "DataStream", value: 0 },
    { label: this.props.t("dashboard.device"), value: 1 },
    { label: this.props.t("dashboard.reports"), value: 2 },
  ];
  docFormat = [
    { label: "CSV", value: 0 },
    { label: "PDF", value: 1 },
  ];
  sortBy = [
    { label: this.props.t("dashboard.oldest"), value: 0 },
    { label: this.props.t("dashboard.latest"), value: 1 },
  ];

  componentDidMount() {
    const { users, deviceList, modalData } = this.props;
    if (Object.keys(modalData).length) {
      // edit case
      const { report } = modalData;
      const { formReport } = this.state;

      let postedUsers = [];
      //   report.reportsUsers.map((user) => {
      //     postedUsers.push(user.users);
      //   });
      report.reportsUsers.forEach((user) => postedUsers.push(user.users));

      let newUserArray = [];
      //   const userArray = postedUsers.map((el) => {
      //     const array = users.filter((user) => {
      //       if (user.id !== el.id) {
      //         newUserArray.push(user);
      //       }
      //     });
      //   });

      if (postedUsers.length) {
        postedUsers.forEach((el) =>
          users.forEach((user) => {
            if (user.id !== el.id) {
              newUserArray.push(user);
            }
          })
        );
      } else {
        newUserArray.push(...users);
      }

      let postedDevices = [];
      //   report.reportsDevices.map((device) => {
      //     postedDevices.push(device.devices);
      //   });
      report.reportsDevices.forEach((device) =>
        postedDevices.push(device.devices)
      );

      let newDeviceArray = [];
      //   const deviceArray = postedDevices.map((el) => {
      //     const array = deviceList.map((device) => {
      //       if (device.id !== el.id) {
      //         newDeviceArray.push(device);
      //       }
      //     });
      //   });
      postedDevices.forEach((el) =>
        deviceList.forEach((device) => {
          if (device.id !== el.id) {
            newDeviceArray.push(device);
          }
        })
      );
      this.setState({
        formReport: {
          ...formReport,
          reportName: report.name,
          tempEnabled:
            report.temp === this.props.t("dashboard.enabled") ? true : false,
          pressureEnabled:
            report.pressure === this.props.t("dashboard.enabled"),
          humidityEnabled:
            report.humidity === this.props.t("dashboard.enabled")
              ? true
              : false,
          shtTEnabled:
            report.thermoCouple === 1
              ? true
              : false,
          carbonEnabled:
            report.carbon === this.props.t("dashboard.enabled") ? true : false,
          insightReport: report.insightReport === 1 ? true : false,
          selectedFreq: report.frequency,
          selectedReportTime: report.duration,
          // selectedGroupData: report.group,
          notifyAdmin: report.adminEnable === 1 ? true : false,
          alarmEnabled:
            report.enable === this.props.t("dashboard.enabled") ? true : false,
          selectedUsers: postedUsers,
          selectedDevices: postedDevices,
          offset: report.offset,
          docFormat: report.format,
          sortBy: report.sortBy,
          timezone: {
            value: report.timezone,
          },
        },
        dropDownUsers: newUserArray,
        dropDownDevices: newDeviceArray,
        mode: "Edit",
        reportId: report.id,
      });
    } else {
      this.setState({
        dropDownUsers: users,
        dropDownDevices: deviceList,
      });
    }
  }

  addReportFn = (payload) => {
    const { addReport } = this.props;
    addReport(payload);
  };

  editReportFn = (payload, id) => {
    const { editReport } = this.props;
    editReport({ payload, id });
  };

  handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const { formReport } = this.state;
    formReport[name] = checked;
    this.setState({
      formReport,
    });
  };

  handleButtonChange = (key, value) => {
    const { formReport } = this.state;
    formReport[key] = value;
    this.setState({
      formReport,
    });
  };

  handleChangeDevice = (selectedDevice) => {
    const { deviceList } = this.props;
    if (!!selectedDevice && selectedDevice.id) {
      const isExisting = this.state.formReport.selectedDevices.find((el) => {
        return el.id === selectedDevice.id;
      });
      if (!isExisting) {
        this.setState(
          {
            deviceId: selectedDevice,
            formReport: {
              ...this.state.formReport,
              selectedDevices: [
                ...this.state.formReport.selectedDevices,
                selectedDevice,
              ],
            },
          },
          () => {
            const array = deviceList.filter((el) => {
              return !this.state.formReport.selectedDevices.includes(el);
            });

            this.setState({
              dropDownDevices: array,
            });
          }
        );
      } else {
        showToast(this.props.t("dashboard.deviceAlreadyExists"), "error");
      }
    }
  };

  handleChangeUser = (selectedUser) => {
    if (!!selectedUser && selectedUser.email) {
      const isExisting = this.state.formReport.selectedUsers.find((el) => {
        return el.email === selectedUser.email;
      });
      if (!isExisting) {
        this.setState(
          {
            userId: selectedUser,
            formReport: {
              ...this.state.formReport,
              selectedUsers: [
                ...this.state.formReport.selectedUsers,
                selectedUser,
              ],
            },
          },
          () => {
            const array = this.props.users.filter((el) => {
              return !this.state.formReport.selectedUsers.includes(el);
            });

            this.setState({
              dropDownUsers: array,
            });
          }
        );
      } else {
        showToast(this.props.t("dashboard.userAlreadyExists"), "error");
      }
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { dashboard } = this.props;
    const { userInfo } = dashboard;
    let userRole = "";
    if (userInfo) {
      const { role } = userInfo;
      userRole = role;
    }
    const { formReport, reportId, mode } = this.state;
    if (formReport.reportName.length === 0) {
      showToast(this.props.t("dashboard.reportNameIsRequired"), "error");
      return false;
    }
    if (formReport.timezone.length === 0) {
      showToast(this.props.t("dashboard.timezoneIsRequired"), "error");
      return false;
    }
    if (userRole === "super_user") {
      if (formReport.selectedUsers.length === 0 && !formReport.notifyAdmin) {
        showToast(this.props.t("dashboard.pleaseEnterAtleastOneUser"), "error");
        return false;
      }
    }
    if (formReport.selectedDevices.length === 0) {
      showToast(this.props.t("dashboard.pleaseEnterAtleastOneDevice"), "error");
      return false;
    }
    // this.setState(state);
    const users = [];
    formReport.selectedUsers.forEach((user) => {
      users.push(user.id);
    });

    const devices = [];
    formReport.selectedDevices.forEach((device) => {
      devices.push(device.id);
    });

    const params = {
      name: formReport.reportName,
      temp: formReport.tempEnabled === true ? 1 : 0,
      carbon: formReport.carbonEnabled === true ? 1 : 0,
      insightReport: formReport.insightReport === true ? 1 : 0,
      humidity: formReport.humidityEnabled === true ? 1 : 0,
      pressure: formReport.pressureEnabled === true ? 1 : 0,
      thermo_couple: formReport.shtTEnabled === true ? 1 : 0,
      adminEnable: formReport.notifyAdmin === true ? 1 : 0,
      enable: formReport.alarmEnabled === true ? 1 : 0,
      frequency: formReport.selectedFreq,
      group: 1,
      offset: formReport.offset,
      timezone: formReport.timezone.value,
      format: formReport.docFormat,
      sortBy: formReport.sortBy,
      type: REPORT_NORMAL,
      duration: "",
      devices,
      users,
    };
    if (params.frequency === 1) {
      params.duration = 0;
    } else if (params.frequency === 2) {
      params.duration = 1;
    } else {
      params.duration = 2;
    }
    if (mode === "Add") {
      this.addReportFn(params);
    } else {
      this.editReportFn(params, reportId);
    }
  };

  /* Simplify error check */
  hasError = (formName, inputName, method) => {
    return fieldHasError(this.state, formName, inputName, method);
  };

  removeUser = (user) => {
    const { formReport } = this.state;
    let { selectedUsers } = formReport;
    selectedUsers = selectedUsers.filter((item) => item.email !== user.email);
    const array = this.props.users.filter((el) => {
      return !selectedUsers.includes(el);
    });

    this.setState({
      formReport: {
        ...this.state.formReport,
        selectedUsers: [...selectedUsers],
      },
      dropDownUsers: array,
    });
  };

  removeDevice = (device) => {
    const { formReport } = this.state;
    let { selectedDevices } = formReport;
    selectedDevices = selectedDevices.filter((item) => item.id !== device.id);
    const array = this.props.deviceList.filter((el) => {
      return !selectedDevices.includes(el);
    });
    this.setState({
      formReport: {
        ...this.state.formReport,
        selectedDevices: [...selectedDevices],
      },
      dropDownDevices: array,
    });
  };
  handleTimeZoneChange = (e) => {
    let value = e.value;
    let zoneTime = moment().tz(value);
    let offset = zoneTime.utcOffset();
    this.setState({
      formReport: {
        ...this.state.formReport,
        timezone: {
          value: value,
        },
        offset: offset,
      },
    });
  };
  render() {
    const { toggleModal, dashboard, t, lng } = this.props;
    const { userInfo } = dashboard;
    let userRole = "";
    if (userInfo) {
      const { role } = userInfo;
      userRole = role;
    }
    const {
      mode,
      formReport,
      userId,
      deviceId,
      dropDownUsers,
      dropDownDevices,
    } = this.state;

    return (
      <React.Fragment>
        <form className="mb-3" name="formDevice" onSubmit={this.onSubmit}>
          <ModalHeader tag="strong" toggle={toggleModal}>
            {lng === "gr" && t("dashboard.report")}{" "}
            <span style={{ textTransform: "lowercase" }}>
              {mode === "Add" ? t("dashboard.add") : t("dashboard.edit")}
            </span>{" "}
            {lng !== "gr" && t("dashboard.report")}
          </ModalHeader>
          <ModalBody>
            <div className="form-group col-12 px-0 d-flex justify-content-between align-item-center">
              <h4>
                {t("dashboard.insightReport")}
              </h4>
              <div className="enableCheckbox">
                <Input
                  type="checkbox"
                  id="insightReport"
                  name="insightReport"
                  checked={formReport.insightReport}
                  onChange={this.handleCheckboxChange}
                />
                <label htmlFor="insightReport">
                  <span className="ui"></span>
                </label>
              </div>
            </div>
            <div className="form-group">
              <label className="text-muted">{t("dashboard.reportName")}</label>
              <div className="input-group with-focus">
                <Input
                  type="text"
                  name="reportName"
                  placeholder={t("dashboard.enterReportName")}
                  invalid={this.hasError(
                    "formReport",
                    "reportName",
                    "required"
                  )}
                  onChange={(e) =>
                    this.handleButtonChange("reportName", e.target.value, e)
                  }
                  data-validate='["required"]'
                  value={
                    !!this.state.formReport.reportName.trim()
                      ? this.state.formReport.reportName
                      : ""
                  }
                  minLength="2"
                />
                {this.hasError("formReport", "reportName", "required") && (
                  <span className="invalid-feedback">
                    {t("dashboard.reportNameIsRequired")}
                  </span>
                )}
              </div>
            </div>
            <div className="form-group">
              <label className="text-muted">
                {t("dashboard.selectDataStream")}
              </label>
              <div className="container-fluid">
                <div className="tempSlider row mt-2">
                  <div className="col-lg-3 col-sm-6 d-flex justify-content-start align-item-center">
                    <div className="enableCheckbox">
                      <p>
                        <Input
                          type="checkbox"
                          id="tempEnabled"
                          name="tempEnabled"
                          checked={formReport.tempEnabled}
                          onChange={this.handleCheckboxChange}
                        />
                        <label htmlFor="tempEnabled">
                          <span className="ui"></span>
                          <span>{t("dashboard.temperature")}</span>
                        </label>
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 d-flex justify-content-start align-item-center">
                    <div className="enableCheckbox">
                      <p>
                        <Input
                          type="checkbox"
                          id="humidityEnabled"
                          name="humidityEnabled"
                          checked={formReport.humidityEnabled}
                          onChange={this.handleCheckboxChange}
                        />
                        <label htmlFor="humidityEnabled">
                          <span className="ui"></span>
                          {t("dashboard.humidity")}
                        </label>
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 d-flex justify-content-start align-item-center">
                    <div className="enableCheckbox">
                      <p>
                        <Input
                          type="checkbox"
                          id="carbonEnabled"
                          name="carbonEnabled"
                          checked={formReport.carbonEnabled}
                          onChange={this.handleCheckboxChange}
                        />
                        <label htmlFor="carbonEnabled">
                          <span className="ui"></span>
                          CO₂
                        </label>
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 d-flex justify-content-start align-item-center">
                    <div className="enableCheckbox">
                      <p>
                        <Input
                          type="checkbox"
                          id="pressureEnabled"
                          name="pressureEnabled"
                          checked={formReport.pressureEnabled}
                          onChange={this.handleCheckboxChange}
                        />
                        <label htmlFor="pressureEnabled">
                          <span className="ui"></span>
                          {t("dashboard.pressure")}
                        </label>
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 d-flex justify-content-start align-item-center">
                    <div className="enableCheckbox">
                      <p>
                        <Input
                          type="checkbox"
                          id="shtTEnabled"
                          name="shtTEnabled"
                          checked={formReport.shtTEnabled}
                          onChange={this.handleCheckboxChange}
                        />
                        <label htmlFor="shtTEnabled">
                          <span className="ui"></span>
                          {t("dashboard.thermocouple")}
                        </label>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {formReport.selectedUsers.length ? (
              <div>
                <label className="text-muted mt-2">
                  {t("dashboard.addedUsers")}
                </label>
                <div className="locations alarmUsers">
                  {formReport.selectedUsers.map((user, index) => (
                    <div
                      className="locationDiv align-items-center d-flex flex-row overflow-auto"
                      key={index}
                      ref={index}
                    >
                      <div className="w-75 d-flex flex-column">
                        <p className="pl-1 pr-1 m-0 w-100 text-uppercase font-weight-bold">
                          {user.name || ""}
                        </p>
                        <p className="pl-1 pr-1 m-0 w-100 font-weight-bold">
                          {user.email || ""}
                        </p>
                        <p className="pl-1 pr-1 m-0 w-100 font-weight-bold">
                          {user.countryCode}-{user.phoneNumber || ""}
                        </p>
                      </div>
                      <div className="w-25 text-right">
                        <button
                          type="button"
                          className="transparentBtn"
                          id="removeButton"
                          onClick={() => this.removeUser(user)}
                        >
                          <i className=" fas fa-trash mt-0"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
            {userRole === "super_user" && (
              <div className="form-group">
                <label className="text-muted">
                  {t("dashboard.selectUsers")}
                </label>
                <Select
                  styles={selectStyle}
                  name="userId"
                  value={userId}
                  onChange={this.handleChangeUser}
                  options={dropDownUsers}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option}`}
                />
              </div>
            )}
            {formReport.selectedDevices.length ? (
              <div>
                <label className="text-muted mt-2">
                  {t("dashboard.addedDevices")}
                </label>
                <div className="locations alarmUsers">
                  {formReport.selectedDevices.map((device, index) => (
                    <div
                      className="locationDiv align-items-center d-flex flex-row overflow-auto"
                      key={index}
                      ref={index}
                    >
                      <div className="w-75 d-flex flex-column">
                        <p className="pl-1 pr-1 m-0 w-100 text-uppercase font-weight-bold">
                          {device.name || ""}
                        </p>
                      </div>
                      <div className="w-25 text-right">
                        <button
                          className="transparentBtn"
                          type="button"
                          id="removeDevices"
                          onClick={() => this.removeDevice(device)}
                        >
                          <i className=" fas fa-trash mt-0"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
            <div className="form-group">
              <label className="text-muted">
                {t("dashboard.selectDevices")}
              </label>
              <Select
                styles={selectStyle}
                name="deviceId"
                id="deviceId"
                value={deviceId}
                onChange={this.handleChangeDevice}
                options={dropDownDevices}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option}`}
              />
            </div>
            <div className="form-group">
              <label className="text-muted">
                {" "}
                {t("dashboard.selectTimezone")}
              </label>
              <TimezoneSelect
                styles={selectStyle}
                name="timezone"
                id="timeZone"
                data-validate='["required"]'
                value={formReport.timezone}
                onChange={this.handleTimeZoneChange}
              />
            </div>
            <div className="form-group">
              <label className="text-muted">
                {t("dashboard.reportFrequency")}
              </label>
              <div className="frequency mt-2">
                {this.freqButtons.map((each, index) => {
                  return (
                    <Button
                      key={index}
                      color="info"
                      className={`mb-2 ${
                        formReport.selectedFreq === each.value
                          ? "active"
                          : "inactive"
                      }`}
                      onClick={() =>
                        this.handleButtonChange("selectedFreq", each.value)
                      }
                    >
                      {each.label}
                    </Button>
                  );
                })}
              </div>
            </div>
            {/* <div className='form-group'>
              <label className='text-muted'>Report For Last</label>
              <div className='frequency mt-2'>
                {reportTime.map((each, index) => {
                  return (
                    <Button
                      key={index}
                      color='info'
                      className={
                        `mb-2 ${formReport.selectedReportTime === each.value
                          ? 'active'
                          : ''}`
                      }
                      onClick={() =>
                        this.handleButtonChange(
                          'selectedReportTime',
                          each.value
                        )
                      }>
                      {each.label}
                    </Button>
                  );
                })}
              </div>
            </div> */}
            {/* <div className="form-group">
              <label className="text-muted">Group Data In Reports By</label>
              <div className="frequency mt-2">
                {this.groupData.map((each, index) => {
                  return (
                    <Button
                      key={index}
                      color="info"
                      className={`mb-2 ${
                        formReport.selectedGroupData === each.value
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        this.handleButtonChange("selectedGroupData", each.value)
                      }
                    >
                      {each.label}
                    </Button>
                  );
                })}
              </div>
            </div> */}
            <div className="form-group">
              <label className="text-muted">
                {t("dashboard.documentFormat")}
              </label>
              <div className="frequency mt-2">
                {this.docFormat.map((each, index) => {
                  return (
                    <Button
                      key={index}
                      color="info"
                      className={`mb-2 ${
                        formReport.docFormat === each.value
                          ? "active"
                          : "inactive"
                      }`}
                      onClick={() =>
                        this.handleButtonChange("docFormat", each.value)
                      }
                    >
                      {each.label}
                    </Button>
                  );
                })}
              </div>
            </div>
            <div className="form-group">
              <label className="text-muted">{t("dashboard.dataSortBy")}</label>
              <div className="frequency mt-2">
                {this.sortBy.map((each, index) => {
                  return (
                    <Button
                      key={index}
                      color="info"
                      className={`mb-2 ${
                        formReport.sortBy === each.value ? "active" : "inactive"
                      }`}
                      onClick={() =>
                        this.handleButtonChange("sortBy", each.value)
                      }
                    >
                      {each.label}
                    </Button>
                  );
                })}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex flex-row mb-2">
                  <div className="form-group enableCheckbox m-0 mr-3">
                    <p>
                      <Input
                        type="checkbox"
                        id="notifyAdmin"
                        name="notifyAdmin"
                        checked={formReport.notifyAdmin}
                        onChange={this.handleCheckboxChange}
                      />
                      <label htmlFor="notifyAdmin">
                        <span className="ui"></span>
                        {t("dashboard.notifyAdmin")}
                      </label>
                    </p>
                  </div>
                  <div className="form-group enableCheckbox m-0">
                    <p>
                      <Input
                        type="checkbox"
                        id="alarmEnabled"
                        name="alarmEnabled"
                        checked={formReport.alarmEnabled}
                        onChange={this.handleCheckboxChange}
                      />
                      <label htmlFor="alarmEnabled">
                        <span className="ui"></span>
                        {t("dashboard.reportEnabled")}
                      </label>
                    </p>
                  </div>
                </div>
                <div className="d-flex">
                  <Button color="info" type="submit">
                    {mode === "Add" ? t("dashboard.add") : t("dashboard.save")}
                  </Button>
                  <Button
                    className="ml-2"
                    color="secondary"
                    type="button"
                    onClick={toggleModal}
                  >
                    {t("dashboard.cancel")}
                  </Button>
                </div>
              </div>
            </div>
          </ModalFooter>
        </form>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.users.userList,
    deviceList: state.devices.deviceList,
    locations: state.locationsDevices.locations,
    dashboard: state.dashboard.dashboard,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addReport: (data) => dispatch(actions.addReport(data)),
    editReport: (data) => dispatch(actions.editReport(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(AddEditEnvironmentReport));
